export default "__VITE_ASSET__6de2fd1b__"